(() => {
  const dateAtNoon = (year, month, day) => new Date(year, month, day, 12);

  const dateKey = (date) => [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

  const observedDate = (date) => {
    const observed = new Date(date);
    if (observed.getDay() === 6) observed.setDate(observed.getDate() - 1);
    if (observed.getDay() === 0) observed.setDate(observed.getDate() + 1);
    return observed;
  };

  const nthWeekday = (year, month, weekday, occurrence) => {
    const date = dateAtNoon(year, month, 1);
    date.setDate(1 + ((7 + weekday - date.getDay()) % 7) + ((occurrence - 1) * 7));
    return date;
  };

  const lastWeekday = (year, month, weekday) => {
    const date = dateAtNoon(year, month + 1, 0);
    date.setDate(date.getDate() - ((7 + date.getDay() - weekday) % 7));
    return date;
  };

  const holidayKeysForYear = (year) => {
    const fixed = [
      dateAtNoon(year, 0, 1),
      dateAtNoon(year, 5, 19),
      dateAtNoon(year, 6, 4),
      dateAtNoon(year, 10, 11),
      dateAtNoon(year, 11, 25),
    ];
    const floating = [
      nthWeekday(year, 0, 1, 3),
      nthWeekday(year, 1, 1, 3),
      lastWeekday(year, 4, 1),
      nthWeekday(year, 8, 1, 1),
      nthWeekday(year, 9, 1, 2),
      nthWeekday(year, 10, 4, 4),
    ];
    return [...fixed.map(observedDate), ...floating].map(dateKey);
  };

  const holidayKeysAround = (date) => new Set([
    ...holidayKeysForYear(date.getFullYear() - 1),
    ...holidayKeysForYear(date.getFullYear()),
    ...holidayKeysForYear(date.getFullYear() + 1),
  ]);

  const isBusinessDay = (date, holidays) => {
    const weekday = date.getDay();
    return weekday !== 0 && weekday !== 6 && !holidays.has(dateKey(date));
  };

  const addBusinessDays = (source, count) => {
    const date = new Date(source);
    const holidays = holidayKeysAround(date);
    let remaining = count;
    while (remaining > 0) {
      date.setDate(date.getDate() + 1);
      if (isBusinessDay(date, holidays)) remaining -= 1;
    }
    return date;
  };

  const addCalendarDays = (source, count) => {
    const date = new Date(source);
    date.setDate(date.getDate() + count);
    return date;
  };

  const formatRange = (start, end) => {
    const sameYear = start.getFullYear() === end.getFullYear();
    const short = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' });
    const long = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    return `${sameYear ? short.format(start) : long.format(start)}–${long.format(end)}`;
  };

  const update = (element) => {
    const now = new Date();
    const today = dateAtNoon(now.getFullYear(), now.getMonth(), now.getDate());
    const standard = element.querySelector('[data-rsp-standard-dates]');
    const priority = element.querySelector('[data-rsp-priority-dates]');
    if (standard) {
      standard.textContent = formatRange(
        addCalendarDays(addBusinessDays(today, 3), 5),
        addCalendarDays(addBusinessDays(today, 4), 7),
      );
    }
    if (priority) {
      priority.textContent = formatRange(
        addCalendarDays(addBusinessDays(today, 1), 5),
        addCalendarDays(addBusinessDays(today, 2), 7),
      );
    }
  };

  const init = () => document.querySelectorAll('[data-rsp-delivery-estimate]').forEach(update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
